var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg"},[_vm._v("\n  "+_vm._s(_vm.moderatorList)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }